import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import app from './routes/app'
import defines from './routes/defines'
import suppliers from './routes/suppliers'
import customers from './routes/customers'
import offers from './routes/offers'
import products from './routes/products'
import hrDefines from './routes/hrDefines'
import hr from './routes/hr'
import configs from './routes/Configs'
import users from './routes/Users'
import userTypes from './routes/User_types'
import workers from './routes/Workers'
import services from './routes/Services'
import serviceTypes from './routes/Service_types'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...defines,
    ...suppliers,
    ...customers,
    ...offers,
    ...products,
    ...hrDefines,
    ...hr,
    ...configs,
    ...users,
    ...userTypes,
    ...workers,
    ...services,
    ...serviceTypes,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
